/**
 * 日志工具类
 * 自动根据环境判断是否输出日志
 * 生产环境不输出 console.log 和 console.info，但保留 console.warn 和 console.error
 */

const isProduction = process.env.NODE_ENV === 'production'

const logger = {
  /**
   * 普通日志（开发环境输出）
   */
  log (...args) {
    if (!isProduction) {
      console.log(...args)
    }
  },

  /**
   * 信息日志（开发环境输出）
   */
  info (...args) {
    if (!isProduction) {
      console.info(...args)
    }
  },

  /**
   * 警告日志（所有环境都输出）
   */
  warn (...args) {
    console.warn(...args)
  },

  /**
   * 错误日志（所有环境都输出）
   */
  error (...args) {
    console.error(...args)
  },

  /**
   * 调试日志（开发环境输出，带标签）
   */
  debug (tag, ...args) {
    if (!isProduction) {
      console.log(`[${tag}]`, ...args)
    }
  },

  /**
   * 分组日志（开发环境输出）
   */
  group (label, callback) {
    if (!isProduction) {
      console.group(label)
      if (typeof callback === 'function') {
        callback()
      }
      console.groupEnd()
    } else if (typeof callback === 'function') {
      callback()
    }
  },

  /**
   * 表格日志（开发环境输出）
   */
  table (data) {
    if (!isProduction) {
      console.table(data)
    }
  }
}

export default logger
